import React from 'react'
import { Step, SingleAnswer } from '../../components'

const RESPONSIBILITY = {
  key: 'admin_responsibility',
  trackingKey: 'responsibility',
  question: 'I have responsibility for...',
  choices: [
    {
      icon: '🏫',
      text: 'My School',
      value: 'my_school'
    },
    {
      icon: '🏙',
      text: 'My District',
      value: 'my_district'
    },
    {
      icon: '🏫 🏙️️',
      text: 'My School & District',
      value: 'school_and_district'
    },
    { text: 'None', value: 'none' }
  ]
}

export const AdminResponsibility = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={RESPONSIBILITY.trackingKey}
      itemsCount={RESPONSIBILITY.choices.length}
      title={RESPONSIBILITY.question}
      subtitle='Select one (Required)'
    >
      {RESPONSIBILITY.choices.map(({ icon, text, value }) => (
        <SingleAnswer
          key={`${text}-${value}`}
          question={RESPONSIBILITY.question}
          surveyKey={RESPONSIBILITY.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
